import { TextField, TextFieldProps } from "@mui/material";
import { Field } from "formik";

export const RevivnFormTextField = (props: TextFieldProps) => (
  <Field
    as={TextField}
    {...props}
    size={props.size || "small"}
    slotProps={{ inputLabel: { shrink: true } }}
    value={props.value ?? ""}
  />
);
